import 'date-input-polyfill-react'
import moment from 'moment'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Dropdown from '@jimmyboys/liita-ui/dist/components/Dropdown'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import React, { useState } from 'react'
import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'

import styles from './Dialog.module.sass'
import TaskHeaderErrors from 'components/TaskHeaderErrors/TaskHeaderErrors'
import Datepicker from 'components/Datepicker/Datepicker'
import { useFetchList } from 'store'
import { Options } from 'models'
import { translateErrorMessage } from 'hooks/useSubmitTask'

const DisableUser = (props) => {
	const { className, data, resolve, dismiss } = props
	const { user } = data
	const { i18n, expireSession, pushNotification } = useGlobal()
	const [replacementUser, setReplacementUser] = useState('none')
	const [startDate, setStartDate] = useState(moment())
	const [endDate, setEndDate] = useState(moment())
	const [submitting, setSubmitting] = useState(false)
	const [error, setError] = useState(null)

	const {
		contents: [replacementUsers = []],
	} = useFetchList(
		['/metadata/task_eligible_users'],
		[Options.fromSimpleObjectJSON]
	)

	const handleSubmit = (e) => {
		e.preventDefault()
		const url = `${API_URL}/api/users/${user?.id}/unavailable`
		setError(null)
		setSubmitting(true)
		let formData = {
			replacementUserId:
				replacementUser !== 'none' ? replacementUser : undefined,
			startDate: startDate,
			endDate: endDate,
		}

		fetch(
			url,
			fetchOptions({
				method: 'PUT',
				body: formData,
			})
		)
			.then((r) => parseJSONContent(r))
			.then(() => {
				resolve && resolve()
				pushNotification(
					undefined,
					'success',
					i18n`User disabled successfully!`
				)
			})
			.catch((err) => {
				if (err.status === '401' || err.status === 401) {
					expireSession()
				}

				const errorMessage = translateErrorMessage(err, i18n)

				setSubmitting(false)
				setError([errorMessage])
			})
	}

	return (
		<>
			<TaskHeaderErrors errors={error ?? []} />
			<form
				id={'form_notification'}
				className={`${styles['root'] || ''} ${className || ''}`}
				onSubmit={handleSubmit}
			>
				<fieldset>
					<Datepicker
						type='datetime-local'
						text={i18n`Start Date`}
						onChange={(date) => {
							setStartDate(date)
						}}
					/>
					<Datepicker
						type='datetime-local'
						text={i18n`End Date`}
						onChange={(date) => {
							setEndDate(date)
						}}
					/>
					<Dropdown
						placeholder={i18n`Replacement User`}
						layout='horizontal'
						options={[
							{ text: 'Nenhum', value: 'none' },
							...(replacementUsers || []),
						]}
						value={replacementUser}
						optionsAlign='right'
						onChange={(e) => {
							setReplacementUser(e.target.value)
						}}
					/>
				</fieldset>
			</form>
			<menu>
				<ActionButton type='button' secondary onClick={dismiss}>
					<small>
						<strong>{i18n`Cancel`}</strong>
					</small>
				</ActionButton>
				<ActionButton form={'form_notification'} primary>
					<small>
						<strong>
							{submitting ? i18n`Submitting` : i18n`Send`}
						</strong>
					</small>
				</ActionButton>
			</menu>
		</>
	)
}

export default DisableUser
